import { Button, Icon } from '@ps/isp-web-component-library';
import { Refresh } from '@ps/isp-web-component-library/icons/Refresh';
import { getWindow } from '@ps/web-core-utils';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Message } from '@swf/sports/components';
import type { MessageSpacingSize } from '@swf/sports/components/Message/Message';

import {
  TXTWCL_SorryX_something_went_wrongX_P_ELL,
  TXTWCL_Try_again
} from './TryAgainMessage.messages.json';
import styles from './TryAgainMessage.scss';

interface Props {
  size?: MessageSpacingSize;
  onRetry?: () => void;
}

const TryAgainMessage: React.FC<Props> = ({
  size,
  onRetry = () => getWindow()?.location.reload()
}) => (
  <Message message={<Translation {...TXTWCL_SorryX_something_went_wrongX_P_ELL} />} size={size}>
    <Button onClick={onRetry}>
      <span className={styles.withIcon}>
        <Icon icon={Refresh} className={styles.icon} size="x1" />
        <Translation {...TXTWCL_Try_again} />
      </span>
    </Button>
  </Message>
);

export { TryAgainMessage };
